import React, { useState, useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { logEvent } from "@/lib/analytics";

const WHATSAPP_NUMBER = "919028230554";

const createWhatsAppLink = (pack) => {
  const message = encodeURIComponent(`I want to buy the Alice Bot ${pack} Pack`);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
};

const StickyWhatsAppCTA = () => {
  const [visible, setVisible] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <a
      href={createWhatsAppLink("General")}
      target="_blank"
      rel="noopener noreferrer"
      className={`fixed bottom-6 right-6 z-50 bg-whatsapp hover:bg-[#128C7E] text-white rounded-full p-4 shadow-lg shadow-whatsapp/40 transition-all duration-500 hover:scale-110 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
      data-testid="sticky-whatsapp-cta"
      onClick={() => logEvent('Contact', 'Click', 'WhatsApp Sticky')}
    >
      <span className="absolute inset-0 rounded-full bg-whatsapp animate-ping opacity-30" />
      <MessageCircle className="w-6 h-6 relative z-10" />
    </a>
  );
};

export default StickyWhatsAppCTA;
